<section class="entry-panel">
  <p class="entry-comment-content">{{entryData?.description}}</p>
  <div class="subtitle-container">
    <pre class="entry-subtitle">{{entryData?.formattedSubtitle}}</pre>
    <p class="entry-subtitle">{{entryData?.keyWorkerName | titlecase}}</p>
  </div>
</section>
